import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import NagusiBackNav from '../common/NagusiBackNav';
import PlayerDirectoryCard from './PlayerDirectoryCard';
import { normalizeSearchText, matchesSearch } from '../../common/utils/normalize';
export default class PlayerDirectoryPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "players", []);
    _defineProperty(this, "teams", []);
    _defineProperty(this, "season", null);
    _defineProperty(this, "loading", true);
    // Filter and sort state
    _defineProperty(this, "search", '');
    _defineProperty(this, "selectedTeam", '531');
    _defineProperty(this, "selectedPosition", 'all');
    _defineProperty(this, "sortBy", 'number');
  }
  oninit(vnode) {
    super.oninit(vnode);
    const primaryTeamId = app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531';
    this.selectedTeam = String(primaryTeamId);
    app.setTitle(app.translator.trans('bizkaitarra-lineup.forum.players_directory.meta_title'));
    this.loadDirectory();
  }
  async loadDirectory() {
    this.loading = true;
    m.redraw();
    try {
      const res = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/player-directory")
      });
      this.players = (res.players || []).filter(p => p.entityType !== 'team');
      this.teams = (res.teams || []).map(t => ({
        id: t.id,
        name: t.id === 9579 ? 'Bilbao Athletic' : t.name
      }));
      this.season = res.season || null;

      // Si el equipo primario no está en la lista de equipos, seleccionar el primer equipo o 'ALL'
      if (this.teams.length > 0 && !this.teams.some(t => String(t.id) === this.selectedTeam)) {
        this.selectedTeam = String(this.teams[0].id);
      }
    } catch (e) {
      console.error('Error loading player directory:', e);
      this.players = [];
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  getFilteredPlayers() {
    const q = normalizeSearchText(this.search);
    return this.players.filter(p => {
      // Exclude teams (only players and coaches)
      if (p.entityType === 'team') return false;

      // 1. Filtro por equipo
      if (this.selectedTeam !== 'ALL') {
        const hasTeam = p.teams.some(t => String(t.id) === this.selectedTeam);
        if (!hasTeam) return false;
      }

      // 2. Filtro por posición
      if (this.selectedPosition !== 'all') {
        if (this.selectedPosition === 'coach') {
          if (p.entityType !== 'coach') return false;
        } else {
          if (p.entityType === 'coach') return false;
          const pos = p.positionNormalized || '';
          if (pos !== this.selectedPosition) return false;
        }
      }

      // 3. Filtro por búsqueda de texto (accent-insensitive)
      if (q) {
        const nameMatch = matchesSearch(p.name, q);
        const numberMatch = p.number !== null && String(p.number) === q;
        const placeMatch = p.birthPlace ? matchesSearch(p.birthPlace, q) : false;
        if (!nameMatch && !numberMatch && !placeMatch) return false;
      }
      return true;
    }).sort((a, b) => {
      if (this.sortBy === 'number') {
        const numA = a.number !== null ? a.number : 999;
        const numB = b.number !== null ? b.number : 999;
        if (numA !== numB) return numA - numB;
        return a.name.localeCompare(b.name);
      }
      if (this.sortBy === 'name') {
        return a.name.localeCompare(b.name);
      }
      if (this.sortBy === 'birthday') {
        // Los que cumplen hoy primero (daysToBirthday === 0), luego por días restantes
        const daysA = a.daysToBirthday !== null ? a.daysToBirthday : 9999;
        const daysB = b.daysToBirthday !== null ? b.daysToBirthday : 9999;
        if (daysA !== daysB) return daysA - daysB;
        return a.name.localeCompare(b.name);
      }
      if (this.sortBy === 'rating') {
        var _a$ratingStats, _b$ratingStats;
        const ratingA = (_a$ratingStats = a.ratingStats) != null && _a$ratingStats.average ? Number(a.ratingStats.average) : 0;
        const ratingB = (_b$ratingStats = b.ratingStats) != null && _b$ratingStats.average ? Number(b.ratingStats.average) : 0;
        if (ratingB !== ratingA) return ratingB - ratingA;
        return a.name.localeCompare(b.name);
      }
      return a.name.localeCompare(b.name);
    });
  }
  view() {
    const filteredPlayers = this.getFilteredPlayers();
    const positions = [{
      key: 'all',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_directory.positions.all')
    }, {
      key: 'goalkeeper',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_directory.positions.goalkeeper')
    }, {
      key: 'defender',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_directory.positions.defender')
    }, {
      key: 'midfielder',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_directory.positions.midfielder')
    }, {
      key: 'attacker',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_directory.positions.attacker')
    }, {
      key: 'coach',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_directory.positions.coaches')
    }];
    return m("div", {
      className: "PlayerDirectoryPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      title: app.translator.trans('bizkaitarra-lineup.forum.players_directory.nav_title')
    }), m("div", {
      className: "PlayerDirectory-hero"
    }, m("div", {
      className: "PlayerDirectory-hero-content"
    }, m("h1", {
      className: "PlayerDirectory-hero-title"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.hero_title')), m("p", {
      className: "PlayerDirectory-hero-desc"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.hero_desc')))), m("div", {
      className: "PlayerDirectory-controls"
    }, this.teams.length > 1 && m("div", {
      className: "PlayerDirectory-teamTabs"
    }, this.teams.map(t => m("button", {
      type: "button",
      className: "PlayerDirectory-teamTab ".concat(this.selectedTeam === String(t.id) ? 'is-active' : ''),
      onclick: () => {
        this.selectedTeam = String(t.id);
        m.redraw();
      }
    }, t.name)), m("button", {
      type: "button",
      className: "PlayerDirectory-teamTab ".concat(this.selectedTeam === 'ALL' ? 'is-active' : ''),
      onclick: () => {
        this.selectedTeam = 'ALL';
        m.redraw();
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.team_all'))), m("div", {
      className: "PlayerDirectory-filtersBar"
    }, m("div", {
      className: "PlayerDirectory-searchBox"
    }, m("i", {
      className: "fas fa-search PlayerDirectory-searchIcon"
    }), m("input", {
      type: "text",
      className: "FormControl PlayerDirectory-searchInput",
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.players_directory.search_placeholder'),
      value: this.search,
      oninput: e => {
        this.search = e.target.value;
        m.redraw();
      }
    }), this.search && m("button", {
      type: "button",
      className: "PlayerDirectory-searchClear",
      onclick: () => {
        this.search = '';
        m.redraw();
      }
    }, m("i", {
      className: "fas fa-times"
    }))), m("div", {
      className: "PlayerDirectory-posPills"
    }, positions.map(p => m("button", {
      type: "button",
      className: "PlayerDirectory-posPill ".concat(this.selectedPosition === p.key ? 'is-active' : ''),
      onclick: () => {
        this.selectedPosition = p.key;
        m.redraw();
      }
    }, p.label))), m("div", {
      className: "PlayerDirectory-sortWrapper"
    }, m("label", {
      htmlFor: "player-sort-select",
      className: "PlayerDirectory-sortLabel"
    }, m("i", {
      className: "fas fa-sort-amount-down"
    })), m("select", {
      id: "player-sort-select",
      className: "FormControl PlayerDirectory-sortSelect",
      value: this.sortBy,
      onchange: e => {
        this.sortBy = e.target.value;
        m.redraw();
      }
    }, m("option", {
      value: "number"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.sort_number')), m("option", {
      value: "name"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.sort_name')), m("option", {
      value: "birthday"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.sort_birthday')), m("option", {
      value: "rating"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.sort_rating')))))), this.loading ? m("div", {
      className: "PlayerDirectory-loading"
    }, m(LoadingIndicator, null)) : filteredPlayers.length > 0 ? m("div", {
      className: "PlayerDirectory-grid"
    }, filteredPlayers.map(player => m(PlayerDirectoryCard, {
      key: player.id,
      player: player
    }))) : m("div", {
      className: "PlayerDirectory-empty"
    }, m("i", {
      className: "fas fa-users-slash PlayerDirectory-emptyIcon"
    }), m("h3", null, app.translator.trans('bizkaitarra-lineup.forum.players_directory.empty_title')), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.players_directory.empty_desc')), (this.search || this.selectedPosition !== 'all' || this.selectedTeam !== 'ALL') && m(Button, {
      className: "Button Button--secondary",
      onclick: () => {
        this.search = '';
        this.selectedPosition = 'all';
        m.redraw();
      }
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.btn_clear_filters')))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/PlayerDirectoryPage', PlayerDirectoryPage);